import type { AdminListAutomatedEmailsData } from '@workspace/api-backend'

export type EmailType = NonNullable<NonNullable<AdminListAutomatedEmailsData['query']>['emailType']>

export const EMAIL_TYPE_LABELS: Record<EmailType, string> = {
  founder_welcome: 'Founder: Welcome',
  founder_onboarding_incomplete: 'Founder: Onboarding Incomplete',
  founder_no_pitch: 'Founder: No Pitch',
  founder_pitch_interrupted: 'Founder: Pitch Interrupted',
  founder_dataroom_not_shared: 'Founder: Data Room Not Shared',
  founder_dataroom_viewed: 'Founder: Data Room Viewed',
  founder_evaluation_ready: 'Founder: Evaluation Ready',
  investor_welcome: 'Investor: Welcome',
  investor_onboarding_incomplete: 'Investor: Onboarding Incomplete',
  investor_no_dealflow: 'Investor: No Dealflow',
}

export function getEmailTypeLabel(emailType: string): string {
  return (EMAIL_TYPE_LABELS as Record<string, string>)[emailType] ?? emailType
}
